import { Injectable, signal, computed } from '@angular/core';
import { getFirebaseBackend } from '../../authUtils';
import { User } from '../models/auth.models';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {
	urlApi = environment.urlAPI;
	private _user = signal<User | null>(null);
	private _identity = signal<any | null>(null);
	private _token = signal<string | null>(null);

	user = this._user.asReadonly();
	identity = this._identity.asReadonly();
	isAuthenticated = computed(() => !!this._token());

	constructor(
		private http: HttpClient,
		private router: Router
	) {
		// ✅ Hidratar estado desde storage al iniciar el servicio
		this.loadSessionFromStorage();
	}

	// ✅ Cargar sesión existente al iniciar la app
	private loadSessionFromStorage(): void {
		const token = localStorage.getItem('token');
		const user = localStorage.getItem('user');
		const permissions = localStorage.getItem('permissions');

		if (token) this._token.set(token);
		if (user) this._user.set(JSON.parse(user));
		if (permissions) this._identity.set(JSON.parse(permissions));
	}

	// ✅ Llamar después de un login exitoso
	setSession(token: string, user: any, permissions: any): void {
		localStorage.setItem('token', token);
		localStorage.setItem('user', user);
		localStorage.setItem('permissions', JSON.stringify(permissions));

		this._token.set(token);
		this._user.set(user);
		this._identity.set(permissions);
	}

	// ✅ Logout limpio sin necesidad de location.reload()
	logout(): void {
		// 1. Limpiar estado en memoria
		this._user.set(null);
		this._identity.set(null);
		this._token.set(null);

		// 2. Limpiar storage
		localStorage.clear();
		sessionStorage.clear();

		// 3. Navegar al login
		this.router.navigate(['/account/login']);
	}

	/**
	 * Returns the current user
	 */
	public currentUser(): User {
		return getFirebaseBackend().getAuthenticatedUser();
	}

	login(user: string, password: string): Observable<any> {
		const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		const body = {
			usr_id: user,
			usr_clave: password,
			usr_identificador: user
		};
		return this.http.post(this.urlApi + 'AccesoUsuario/login', body, { headers, observe: 'response' });
	}

	register(params: any): Observable<any> {
		const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		return this.http.post(this.urlApi + 'AccesoUsuario/Register', params, { headers, observe: 'response' });
	}

	validateCode(params: any): Observable<any> {
		const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		return this.http.post(this.urlApi + 'AccesoUsuario/ValidateCode', params, { headers, observe: 'response' });
	}

	resendCode(params: any): Observable<any> {
		const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		return this.http.post(this.urlApi + 'AccesoUsuario/ResendCode', params, { headers, observe: 'response' });
	}

	// ✅ Lee desde el signal, no directo del localStorage
	getHeaders(): { headers: HttpHeaders } {
		return {
			headers: new HttpHeaders({
				Authorization: this._token() ?? ''
			})
		};
	}

	// ✅ Bug corregido: null en lugar de string 'undefined'
	getIdentityObs(): Observable<any> {
		return of(this._identity());
	}

	getCurrentUser(): User | null {
		return this._user();
	}

	// ✅ Firebase (si aún lo necesitas)
	public currentFirebaseUser(): User {
		return getFirebaseBackend().getAuthenticatedUser();
	}

	// login(user: string, password: string): Observable<any> {
	// 	const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
	// 	const body = {
	// 		usr_id: user,
	// 		usr_clave: password,
	// 		usr_identificador: user
	// 	};
	// 	return this.http.post(this.urlApi + 'AccesoUsuario/login', body, { headers, observe: 'response' });
	// }

	// register(params): Observable<any> {
	// 	const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
	// 	return this.http.post(this.urlApi + 'AccesoUsuario/Register', params, { headers, observe: 'response' });
	// }

	// validateCode(params): Observable<any> {
	// 	const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
	// 	return this.http.post(this.urlApi + 'AccesoUsuario/ValidateCode', params, { headers, observe: 'response' });
	// }

	// resendCode(params): Observable<any> {
	// 	const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
	// 	return this.http.post(this.urlApi + 'AccesoUsuario/ResendCode', params, { headers, observe: 'response' });
	// }

	// getHeaders() {
	// 	const headers = new HttpHeaders({
	// 		Authorization: localStorage.getItem('token')
	// 	});
	// 	return { headers };
	// }

	// getIdentityObs(): Observable<any> {
	// 	const identity = JSON.parse(localStorage.getItem('permissions'));
	// 	if (identity !== 'undefined') {
	// 		this.identity = identity;
	// 	}
	// 	return of(this.identity);
	// }

	// getCurrentUser() {
	// 	const user = JSON.parse(localStorage.getItem('user'));
	// 	return user;
	// }
}

